/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar10(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M7 3v5H5v4h3v10h8V12h3V8h-2V3z" opacity=".3"/><path d="M11 7h2v5h-2z"/><path d="M8 7h8v2H8z"/><path d="M18 7V2H6v5H4v6h3v10h10V13h3V7h-2zm-3 14H9v-5h6v5zm3-10h-3v3H9v-3H6V9h2V4h8v5h2v2z"/></svg>
  );
}

export default Avatar_icn_avatar10;
